"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LineHeights", {
  enumerable: true,
  get: function get() {
    return _lineHeights.default;
  }
});
exports.Overflows = exports.TextAlignments = exports.TextTransforms = exports.LetterSpacings = exports.Sizes = exports.Weights = exports.FontFamilies = exports.DisplayModes = exports.baseStyles = exports.fontFamily = void 0;

var _styledComponents = require("styled-components");

var _lineHeights = _interopRequireDefault(require("./generated/line-heights"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  font-family: ", ";\n  color: ", ";\n  margin: 0;\n  padding: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var fontFamily = "\n  DD-TTNorms,\n  -apple-system,\n  BlinkMacSystemFont,\n  \"Segoe UI\",\n  Roboto,\n  Helvetica,\n  Arial,\n  sans-serif,\n  \"Apple Color Emoji\",\n  \"Segoe UI Emoji\",\n  \"Segoe UI Symbol\"\n";
exports.fontFamily = fontFamily;
var baseStyles = (0, _styledComponents.css)(_templateObject(), function (props) {
  return props.size;
}, fontFamily, function (props) {
  return props.color;
});
exports.baseStyles = baseStyles;
var DisplayModes = {
  Inline: 'inline',
  InlineBlock: 'inline-block',
  Block: 'block',
  Flex: 'flex'
};
exports.DisplayModes = DisplayModes;
var FontFamilies = {
  SansSerif: 'SansSerif',
  Serif: 'Serif'
};
exports.FontFamilies = FontFamilies;
var Weights = {
  Regular: '400',
  Medium: '500',
  Bold: '700',
  ExtraBold: '800'
};
exports.Weights = Weights;
var Sizes = {
  S10: 10,
  S12: 12,
  S14: 14,
  S16: 16,
  S18: 18,
  S24: 24,
  S32: 32,
  S40: 40
};
exports.Sizes = Sizes;
var LetterSpacings = {
  Tight: -0.2 / 5,
  Normal: 0,
  Wide: 0.5 / 5
};
exports.LetterSpacings = LetterSpacings;
var TextTransforms = {
  Normal: 'none',
  UpperCase: 'uppercase'
};
exports.TextTransforms = TextTransforms;
var TextAlignments = {
  Left: 'left',
  Center: 'center',
  Right: 'right',
  Justify: 'justify'
};
exports.TextAlignments = TextAlignments;
var Overflows = {
  Truncate: 'truncate',
  BreakWord: 'break-word',
  Wrap: 'normal'
};
exports.Overflows = Overflows;